<div class="container-fluid p-0 mainnnn">
    <div class="row m-0 d-flex justify-content-between bg-color">
        <div class="col-lg-6 p-0  sideimg" [hidden]="isCompanyInterest==false">
            <div class="signupback">
                <img src="assets/images/auth.png">
            </div>
        </div>
        <div [ngClass]="isCompanyInterest==false?'col-lg-12':'col-lg-6'" class="p-0  interest">
            <section class="main_comp ">
                <div>
                    <h1>Choose your interests</h1>
                    <p>Pick a few to help us personalize your account</p>
                </div>
                <div [formGroup]="loginForm">
                    <mat-button-toggle-group name="ingredients" aria-label="Ingredients" multiple
                        formControlName="interest">
                        <mat-button-toggle matRipple [matRippleCentered]="centered" [matRippleDisabled]="disabled"
                            class="cursor-pointer" [matRippleUnbounded]="unbounded" *ngFor="let items of interestName"
                            [value]="items.id"
                            (click)="selectUser(items.id,1)">{{items.interest_name}}</mat-button-toggle>
                    </mat-button-toggle-group>
                    <!-- <mat-button-toggle-group name="ingredients" aria-label="Ingredients" multiple formControlName="custom_interest" >
                        <mat-button-toggle 
                        matRipple
                        [matRippleCentered]="centered"
                        [matRippleDisabled]="disabled"
                        class="cursor-pointer"
                        [matRippleUnbounded]="unbounded" *ngFor="let items of customFields" [value]="items"  (click)="selectUser(items,2)">{{items}}
                        <img src="assets/images/close-circle.png"
                        class="close position-absolute cursor-pointer" (click)="remove(items)"></mat-button-toggle>
                    </mat-button-toggle-group>
                    <small *ngIf="submitted && loginForm.controls['interest'].invalid " class="alert">
                        <small *ngIf="submitted && loginForm.controls['interest'].errors.required">
                            interest is required
                        </small>
                        </small> -->
                    <div *ngIf="customFields.length>0">
                        <h3>Custom Interests</h3>
                        <mat-button-toggle-group name="ingredients" aria-label="Ingredients" multiple
                            formControlName="custom_interest" class='mat_Height_Fix'>
                            <div class="d-flex position-relative" *ngFor="let items of customFields">
                                <mat-button-toggle matRipple [matRippleCentered]="centered"
                                    [matRippleDisabled]="disabled" [matRippleUnbounded]="unbounded"
                                    class="cursor-pointer" [value]="items" (click)="selectUser(items,2)">{{items}}

                                </mat-button-toggle>
                                <img src="assets/images/close-circle.png" class="close cursor-pointer position-absolute"
                                    (click)="remove(items)">
                            </div>
                        </mat-button-toggle-group>
                        <small *ngIf="submitted && loginForm.controls['interest'].invalid " class="alert">
                            <small *ngIf="submitted && loginForm.controls['interest'].errors.required">
                                interest is required
                            </small>
                        </small>
                    </div>

                </div>
            </section>
            <div class="result mt-3 d-flex justify-content-center ">
                <p class="mb-0  d-flex align-items-center">
                    <img class="me-3" src="assets/images/info-circle_red.svg" width="26px" height="26px"> Follow 3 or
                    more categories to get
                    started
                </p>
            </div>
            <section class="main_comp">
                <div class="d-flex justify-content-center main_comp btn-order mt-md-5 mt-3 flex-wrap pb-5">
                    <button class="btn me-sm-2 me-0 mt-2 field" (click)="addCustom()">Add Custom Field</button>
                    <button class="btn ms-sm-2 ms-0 mt-2 post cursor-pointer" (click)="onVerify(loginForm.value)">Save &
                        Continue
                    </button>
                </div>
            </section>

        </div>
    </div>